import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "ml-4" }, " Equipos ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "ml-4" }, " Usuarios ", -1)

import AdminView from '@/views/SmartLink/Admin/AdminView.vue';
import AdminUser from '@/components/RAOS/Management/AdminUser.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(AdminView),
    _hoisted_2,
    _createVNode(AdminUser)
  ], 64))
}
}

})